/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:require('../../../../view/swiper/Swiper')
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/banner/Swiper.js
// module id = 508
// module chunks = 6